module.exports = __webpack_public_path__ + "static/logos-tiles-pmi-2b1a430f9e9243c9da83341e26996891.svg";